import { RouteRecordRaw } from 'vue-router'

import { useOrganisationStore } from '@/stores/organisations'

const Clients = () => import('@/pages/clients/AllClients.vue')
const AnalyticsTrends = () => import('@/pages/analytics/PartnerOrg/Trends.vue')

export const partnerOrgRoutes: RouteRecordRaw[] = [
  {
    path: '/clients',
    name: 'clients',
    component: Clients,
    beforeEnter: () => {
      const organisationStore = useOrganisationStore()
      return organisationStore.currentOrg?.type === 'records'
    },
    meta: {
      breadcrumbs: {
        name: 'Clients',
      },
    },
  },
  // analytics
  {
    path: '/partner-analytics',
    meta: {
      breadcrumbs: {
        name: 'Analytics',
      },
    },
    children: [
      {
        path: 'trends',
        name: 'partner-analytics-trends',
        component: AnalyticsTrends,
        meta: {
          breadcrumbs: {
            name: 'Trends Over Time',
          },
        },
      },
    ],
  },
]
